import Vue from 'vue'
import Vuex from 'vuex'
import { isArrayEmpty, generateCombinations } from '@/utils/utils'
import { CT_PICK_3, INSTANT_SLUG_GAME } from '@/constants/lotto'
import { APK_VERSION_NAME_MAP } from '@/constants/app-version-map'

Vue.use(Vuex)

const isStrEmpty = (str: string): boolean => {
    return !str || str.length === 0 || str === 'undefined'
}

const getUserInfo = () => {
    return localStorage.getItem('user_info') || ''
}

const APK_VERSION_NUMBER_KEY = 'apk_version_number'

const getInitialApkVersionNumber = (): string | null => {
    return localStorage.getItem(APK_VERSION_NUMBER_KEY) || null
}

export default new Vuex.Store({
    state: {
        userInfo: !isStrEmpty(getUserInfo()) ? JSON.parse(getUserInfo()) : null,
        tokenV3: localStorage.getItem('access_tokenv3'),
        cart: [],
        cartRender: [],
        quantity: 0,
        transact459: [],
        transact545: [],
        transactPariLotto: [],
        transactInstantLotto: [],
        transact: [],
        transactPick3: [],
        enabled_game_slugs: '',
        reprintCountToShowCancel: 1,
        showCancelationInPos: false,
        milisecondsToForceFinishPrinting: 2000,
        usersBypassPrintingCheck: '',
        usersSimulatePrintError: '',
        printSimulateMode: 'always-error',
        autoCancelUnprintedCountdownSeconds: 60,
        maxAutoReprintAttempts: 1,
        usersNewReprintDialog: '',
        usingReprintDialog: false,
        networkTimeoutSeconds: 30,
        isShowSports: true,
        isOnlyPayment: true,
        isShow645: true,
        isShow590: true,
        isShow459: true,
        isShow545: true,
        isShowPick3: true,
        isShowInstantLotto: true,
        isShowVoucher: true,
        isShowExtra7Boost: false,
        isLoadingAddCart: false,
        totalCart: 0,
        dataGamesPari: [],
        stepCart: 1,
        apkVersionNumber: getInitialApkVersionNumber(),
        // Extra 7 Boost — active FreeBet redemption context. When set, the next
        // Loto 5/90 Boost purchase is placed as a freebet (no cashier charge) and
        // the coupon is redeemed on success. Null = normal play (no behaviour change).
        freebetContext: !isStrEmpty(localStorage.getItem('freebet_context') || '')
            ? JSON.parse(localStorage.getItem('freebet_context') as string)
            : null,
    },
    getters: {
        mappedAppVersionName: (state) => {
            if (!state.apkVersionNumber) return null
            return APK_VERSION_NAME_MAP[state.apkVersionNumber] ?? state.apkVersionNumber
        },
    },
    mutations: {
        SET_USER_INFO(state, data) {
            state.userInfo = data
        },

        REMOVE_USER_INFO(state) {
            state.userInfo = null
            localStorage.removeItem('user_info')
        },

        SET_TOKEN_V3(state, data) {
            state.tokenV3 = data
        },

        SET_FREEBET_CONTEXT(state, data) {
            state.freebetContext = data
            if (data) {
                localStorage.setItem('freebet_context', JSON.stringify(data))
            } else {
                localStorage.removeItem('freebet_context')
            }
        },

        CLEAR_FREEBET_CONTEXT(state) {
            state.freebetContext = null
            localStorage.removeItem('freebet_context')
        },

        SET_APK_VERSION_NUMBER(state, data) {
            state.apkVersionNumber = data || null
            if (data) {
                localStorage.setItem(APK_VERSION_NUMBER_KEY, data)
            } else {
                localStorage.removeItem(APK_VERSION_NUMBER_KEY)
            }
        },

        SET_DATA_CART(state, data) {
            state.cart = data.cart
            state.cartRender = data.cartRender
            state.quantity = data.quantity
            state.transact = data.transact
            state.totalCart = data.totalCart
            state.transactPariLotto = data.transactPariLotto
            state.transact459 = data.transact459
            state.transact545 = data.transact545
            state.transactPick3 = data.transactPick3

            localStorage.setItem('transactPariLotto', JSON.stringify(data.transactPariLotto))
            localStorage.setItem('transact459', JSON.stringify(data.transact459))
            localStorage.setItem('transact545', JSON.stringify(data.transact545))
            localStorage.setItem(CT_PICK_3.LOCAL_STORAGE_KEY_CART, JSON.stringify(data.transactPick3))
            localStorage.setItem('cartRender', JSON.stringify(data.cartRender ? data.cartRender : []))
            localStorage.setItem('cart', JSON.stringify(data.cart))
            localStorage.setItem('quantity', data.quantity)
            localStorage.setItem('transact', JSON.stringify(data.transact))
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart))
            state.isLoadingAddCart = false
        },

        SET_DATA_CART_NOT_EVENT(state, data) {
            state.transactInstantLotto = data.transactInstantLotto
            state.quantity = data.quantity
            state.totalCart = data.totalCart
            state.cartRender = data.cartRender
            state.cart = data.cart

            localStorage.setItem('cartRender', JSON.stringify(data.cartRender ? data.cartRender : []))
            localStorage.setItem('transactInstantLotto', JSON.stringify(data.transactInstantLotto))
            localStorage.setItem('cart', JSON.stringify(data.cart))
            localStorage.setItem('quantity', data.quantity)
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart))
        },

        SET_DATA_CART_SWITCH(state, data) {
            state.totalCart = data.totalCart
            state.cartRender = data.cartRender
            state.stepCart = data.step
            localStorage.setItem('totalCart', JSON.stringify(data.totalCart))
            localStorage.setItem('cartRender', JSON.stringify(data.cartRender))
            localStorage.setItem('stepCart', JSON.stringify(data.step))
        },
    },
    actions: {
        handleUserInfo({ commit, state }, data) {
            commit('SET_USER_INFO', data)
        },

        removeUserInfo({ commit }) {
            commit('REMOVE_USER_INFO')
        },

        setTokenV3({ commit, state }, data) {
            commit('SET_TOKEN_V3', data)
        },

        onSwitchBetslip({ commit, state }, payload) {
            const { step } = payload
            const cart: any = state.cart
            let type = 'Loto 4/59'

            if (step === 1) {
                type = 'loto-590'
            } else if (step === 2) {
                type = 'lotto-6-45'
            } else if (step === 3) {
                type = 'loto-4-59'
            } else if (step === 4) {
                type = 'lotto-5-45'
            } else if (step === CT_PICK_3.STEP_CART) {
                type = CT_PICK_3.SLUG_GAME
            } else {
                type = INSTANT_SLUG_GAME
            }

            const cartRender = cart.filter((x) => x.gameType === type)
            const totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            const param = {
                totalCart,
                cartRender,
                step,
            }

            commit('SET_DATA_CART_SWITCH', param)
        },

        onAddToCartLottoNotEvent({ commit, state }, payload) {
            const transactInstantLotto: any = state.transactInstantLotto
            const cart: any = state.cart
            let quantity: number = state.quantity
            const payloadTransact = { ...payload, wager: payload.price }

            delete payloadTransact['gameType']
            delete payloadTransact['price']
            delete payloadTransact['date']
            transactInstantLotto.push(payloadTransact)

            cart.push(payload)

            const cartRender = transactInstantLotto

            quantity += 1

            const totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            const param = {
                transactInstantLotto,
                quantity,
                cartRender,
                totalCart,
                cart,
            }

            commit('SET_DATA_CART_NOT_EVENT', param)
        },

        onAddToCart({ commit, state }, payload) {
            const pariMutuelLotto = ['loto-4-59', 'lotto-6-45', 'lotto-5-45']

            const cart: any = state.cart
            let cartRender: any = []
            const transact: any = state.transact
            const transactPariLotto: any = state.transactPariLotto
            const transact459: any = state.transact459
            const transact545: any = state.transact545
            const transactPick3: any = state.transactPick3

            let quantity: number = state.quantity
            let totalCart = 0
            let title = `${payload.title}`
            let game = `${payload.game}`
            let quantityBets = 1

            if (!pariMutuelLotto.includes(payload.gameType) && payload.gameNumber) {
                title += ` ${payload.gameNumber}`
                game += `${payload.gameNumber}`
            }

            const selection = payload.gameType !== CT_PICK_3.SLUG_GAME ? payload.selection.sort((a, b) => a - b) : payload.selection
            payload.event_id.map((eventId, i) => {
                const item = {
                    id: new Date()
                        .getTime()
                        .toString(36)
                        .concat(performance.now().toString(), Math.random().toString())
                        .replace(/\./g, ''),
                    parentId: payload.id,
                    eventId,
                    eventDate: payload.eventInfo[i].date,
                    eventName: payload.eventInfo[i].name,
                    selection: [selection],
                    title,
                    price: payload.wager,
                    bets: 0,
                    gameType: payload.gameType,
                    isPariMutuelLotto: payload?.isPariMutuelLotto,
                    marketOption: '',
                    market_name: payload?.market?.market_name || '',
                }
                if (payload.boost) {
                    item['boost'] = true
                }
                if (payload.free_bet) {
                    item['free_bet'] = true
                }

                if (payload.isPariMutuelLotto && payload.selection.length > payload.numberQp) {
                    quantityBets = generateCombinations(Number(payload.selection.length), Number(payload.numberQp))
                    item['price'] = payload.wager * quantityBets
                    item['bets'] = quantityBets
                }

                if (payload.gameType === 'loto-4-59') item['isPariMutuelLotto'] = false

                switch (payload.selectedBetOption ?? '') {
                    case 'both':
                        cart.push(item)
                        const i = { ...item }
                        i.marketOption = 'double_chance'
                        i.id = new Date()
                        .getTime()
                        .toString(36)
                        .concat(performance.now().toString(), Math.random().toString())
                        .replace(/\./g, ''),
                        cart.push(i)
                        break;
                    case 'double_chance':
                        item.marketOption = 'double_chance'
                        cart.push(item)
                        break;
                    default: 
                        cart.push(item)
                    break;
                }
            })

            const item = {
                id: payload.id,
                selection: [payload.selection],
                draws: payload.draws,
                event_id: payload.event_id,
                wager: payload.wager,
                game,
                market_option: '',
            }
            if (payload.boost) {
                item['boost'] = true
            }
            // FreeBet marker travels with the cart item so the ticket stays a freebet
            // through checkout (independent of the transient freebet context).
            if (payload.free_bet) {
                item['free_bet'] = true
                item['freebet_code'] = payload.freebet_code
                item['freebet_total'] = payload.freebet_total
            }

            if (payload.gameType === 'lotto-6-45') {
                transactPariLotto.push(item)
            } else if (payload.gameType === 'loto-4-59') {
                transact459.push(item)
            } else if (payload.gameType === 'lotto-5-45') {
                transact545.push(item)
            } else if (payload.gameType === CT_PICK_3.SLUG_GAME) {
                item['market'] = payload?.market?.market_slug || ''
                transactPick3.push(item)
            } else {
                switch (payload.selectedBetOption ?? '') {
                    case 'both':
                        transact.push(item)
                        const i = { ...item }
                        i.market_option = 'double_chance'
                        transact.push(i)
                        break;
                    case 'double_chance':
                        item.market_option = 'double_chance'
                        transact.push(item)
                        break;
                    default: 
                        transact.push(item)
                    break;
                }
            }

            cartRender = cart.filter((x) => x.gameType)
            totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            quantity = cart.length

            const param = {
                quantity,
                transact,
                cart,
                totalCart,
                transactPariLotto,
                transact459,
                transact545,
                transactPick3,
                cartRender,
            }

            commit('SET_DATA_CART', param)
        },

        onRemoveItemCart({ commit, state }, payload) {
            const cart: any = state.cart
            let cartRender: any = []
            const transact: any = state.transact
            const transactPariLotto: any = state.transactPariLotto
            const transact459: any = state.transact459
            const transact545: any = state.transact545
            const transactPick3: any = state.transactPick3
            let quantity: number = state.quantity
            let totalCart: number = state.totalCart
            const element = payload.item

            let transactClone: any = []

            if (element.gameType === 'lotto-6-45') {
                transactClone = transactPariLotto
            } else if (element.gameType === 'loto-4-59') {
                transactClone = transact459
            } else if (element.gameType === 'lotto-5-45') {
                transactClone = transact545
            } else if (element.gameType === CT_PICK_3.SLUG_GAME) {
                transactClone = transactPick3
            } else {
                transactClone = transact
            }

            const index = transactClone.findIndex((x) => x.id === element.parentId)

            if (index !== -1) {
                transactClone[index].event_id = transactClone[index].event_id.filter((x) => x !== element.eventId)
            }

            if (isArrayEmpty(transactClone[index]?.event_id)) {
                transactClone.splice(index, 1)
            }

            const indexCart = cart.findIndex((x) => x.id === element.id)

            cart.splice(indexCart, 1)

            cartRender = cart.filter((x) => x.gameType === element.gameType)

            totalCart = cartRender.reduce((a, b) => a + b.price, 0)
            quantity = cart.length
            const param = {
                quantity,
                transact,
                cart,
                totalCart,
                transact459,
                transact545,
                transactPariLotto,
                transactPick3,
                cartRender,
            }

            if (element.gameType === 'lotto-6-45') {
                param['transactPariLotto'] = transactClone
            } else if (element.gameType === 'loto-4-59') {
                param['transact459'] = transactClone
            } else if (element.gameType === 'lotto-5-45') {
                param['transact545'] = transactClone
            } else if (element.gameType === CT_PICK_3.SLUG_GAME) {
                param['transactPick3'] = transactClone
            } else {
                param['transact'] = transactClone
            }

            commit('SET_DATA_CART', param)
        },

        onClearCart({ state, commit }) {
            let cart: any = state.cart

            let type = 'loto-4-59'

            if (state.stepCart === 1) {
                type = 'loto-590'
            } else if (state.stepCart === 2) {
                type = 'lotto-6-45'
            } else if (state.stepCart === 3) {
                type = 'loto-4-59'
            } else if (state.stepCart === 4) {
                type = 'lotto-5-45'
            } else if (state.stepCart === CT_PICK_3.STEP_CART) {
                type = CT_PICK_3.SLUG_GAME
            }else {
                type = INSTANT_SLUG_GAME
            }

            cart = cart.filter((x) => x.gameType !== type)
            const totalCart = cart.reduce((a, b) => a + b.price, 0)
            const quantity = cart.length

            const param = {
                quantity,
                transact: state.stepCart === 1 ? [] : state.transact,
                cart: cart,
                cartRender: [],
                totalCart,
                transactPariLotto: state.stepCart === 2 ? [] : state.transactPariLotto,
                transact459: state.stepCart === 3 ? [] : state.transact459,
                transact545: state.stepCart === 4 ? [] : state.transact545,
                transactPick3: state.stepCart === CT_PICK_3.STEP_CART? [] : state.transactPick3,
            }

            if (type === INSTANT_SLUG_GAME) {
                const paramNotEvent = {
                    transactInstantLotto: [],
                    cartRender: [],
                    quantity,
                    totalCart,
                    cart,
                }

                commit('SET_DATA_CART_NOT_EVENT', paramNotEvent)

                return
            }

            commit('SET_DATA_CART', param)
        },

        onClearCartAll({ commit }) {
            const param = {
                quantity: [],
                transact: [],
                cart: [],
                totalCart: 0,
                transactPariLotto: [],
                transact459: [],
                transact545: [],
                transactPick3: [],
                cartRender: [],
            }
            commit('SET_DATA_CART', param)
        },
    },
})
